// extracted by mini-css-extract-plugin
module.exports = {"copyResult":"styles_copyResult__7jcn_","copyButton":"styles_copyButton__L8eYB","copyIcon":"styles_copyIcon__IFhBr"};